import CommonService from "../Common";
import { SignUpLogInRequest } from "../../interfaces/Auth";
import { AxiosRequestConfig } from "axios";

interface Session {
  pathPrefix?: string;
  commonService: CommonService;
}

class SessionService implements Session {
  pathPrefix?: string;
  commonService: CommonService;

  constructor() {
    this.pathPrefix = "/api/v1/session";
    this.commonService = new CommonService();
  }

  reviewSession() {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: `${this.pathPrefix}/review`,
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }

  verifyTurnstileToken({ token }: any) {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${this.pathPrefix}/verifyturnstiletoken`,
      data: { token },
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }

  logIn({ email, password }: SignUpLogInRequest) {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${this.pathPrefix}/login`,
      data: { email, password },
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }

  logOut() {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: `${this.pathPrefix}/logout`,
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }
}

export default SessionService;
